// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"d9f4f69a","845":"f58c234c"}[chunkId] + ".chunk.css";
};